var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M51.438,0.021C23.834-0.773,0.814,20.96,0.021,48.563C0.007,49.049,0,49.535,0,50.021\r\n\tc0,27.614,22.386,50,50,50s50-22.386,50-50C100.012,22.958,78.488,0.799,51.438,0.021z M43,22.021h14v21h21v14H57v21H43v-21H22v-14\r\n\th21V22.021z"}));
}

Plus.defaultProps = {"height":"100px","width":"100px","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 100 100.021","enableBackground":"new 0 0 100 100.021","xmlSpace":"preserve"};

module.exports = Plus;

Plus.default = Plus;
